import { type ComponentConfig } from "@puckeditor/core";
import { MobileStickyCall, type MobileStickyCallProps } from "./mobile-sticky-call";
import { MobileStickyCallFields } from "./mobile-sticky-call.fields";

/**
 * Puck component configuration for Mobile Sticky Call Button
 *
 * This component should be added once per page, typically alongside the Hero.
 * It auto-populates the phone number from business context.
 */
export const MobileStickyCallConfig: ComponentConfig<MobileStickyCallProps> = {
  label: "Mobile Sticky Call Button",
  fields: {
    phone: MobileStickyCallFields.phone,
    buttonText: { ...MobileStickyCallFields.buttonText, contentEditable: true },
    scrollThreshold: MobileStickyCallFields.scrollThreshold,
    dismissible: MobileStickyCallFields.dismissible,
  },
  defaultProps: {
    phone: "", // Auto-populated from business context
    buttonText: "Call Now",
    scrollThreshold: 400,
    dismissible: true,
  },
  render: ({ puck, ...props }) => {
    // Access business data from Puck metadata OR window config (fallback)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const puckMetadata = puck?.metadata as any;
    const windowConfig =
      typeof window !== "undefined"
        ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (window as any).__SERVICEPRO_CONFIG__
        : {};
    const business = puckMetadata?.business || windowConfig?.business;

    // Get phone number from business context if not provided
    const phone = props.phone || business?.phone || business?.telephone || "";

    // Don't render if no phone available
    if (!phone) {
      return <></>;
    }

    return <MobileStickyCall {...props} phone={phone} />;
  },
};
